export var BrandAvatarSizes;
(function (BrandAvatarSizes) {
    BrandAvatarSizes["small"] = "small";
    BrandAvatarSizes["medium"] = "medium";
    BrandAvatarSizes["large"] = "large";
    BrandAvatarSizes["huge"] = "huge";
})(BrandAvatarSizes || (BrandAvatarSizes = {}));
export var BrandAvatarVariants;
(function (BrandAvatarVariants) {
    BrandAvatarVariants["original"] = "original";
    BrandAvatarVariants["rounded"] = "rounded";
    BrandAvatarVariants["placeholder"] = "placeholder";
})(BrandAvatarVariants || (BrandAvatarVariants = {}));
//# sourceMappingURL=constants.js.map